<template>
	<div class="userHead">
		
	</div>
</template>

<script>
	export default{
		
	}
</script>

<style scoped>
	.userHead{
		width: 100%;
		height: 120px;
		background: url('../../../assets/img/userIndex/bgc.png') 100% 100% no-repeat;
		/* background-color: antiquewhite; */
	}
</style>